export class Education {
    id: string
    level: number
    isContinue: boolean
    schoolName: string
    departmant: string
    startDate: string
    endDate: string
    universityId: number
    isOtherUniversity: boolean
}